import { useEffect, useState } from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { Reveal, Overline } from "./Reveal";

const GallerySection = () => {
    const { t } = useLanguage();
    const [galleryFiles, setGalleryFiles] = useState([]);

    useEffect(() => {
        let mounted = true;
        fetch("/assets/Gallary/gallery-manifest.json")
            .then((response) => {
                if (!response.ok) throw new Error("Gallery manifest unavailable");
                return response.json();
            })
            .then((files) => {
                if (mounted && Array.isArray(files)) setGalleryFiles(files);
            })
            .catch(() => {
                if (mounted) setGalleryFiles([]);
            });

        return () => {
            mounted = false;
        };
    }, []);

    const galleryItems = galleryFiles.map((file, index) => ({
        src: `/assets/Gallary/${file}`,
        alt: t.gallery.items[index]?.alt || t.gallery.title,
    }));

    return (
        <section id="gallery" className="scroll-mt-24 py-12 md:py-20" aria-labelledby="gallery-title" data-testid="gallery-section">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <Reveal className="max-w-2xl">
                    <Overline>{t.gallery.overline}</Overline>
                    <h2 id="gallery-title" className="mt-4 font-display text-3xl font-bold tracking-tight text-ink sm:text-4xl lg:text-5xl">
                        {t.gallery.title}
                    </h2>
                </Reveal>
                <div className="mt-10 grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-5">
                    {galleryItems.map((item, i) => (
                        <Reveal key={item.src} delay={Math.min(i * 0.05, 0.3)} className={i === 4 ? "col-span-2 md:col-span-1" : ""}>
                            <figure
                                className="group overflow-hidden rounded-2xl border border-ink/10 shadow-sm"
                                data-testid={`gallery-item-${i + 1}`}
                            >
                                <img
                                    src={item.src}
                                    alt={item.alt}
                                    width="675"
                                    height="1200"
                                    loading="lazy"
                                    className="aspect-[9/16] w-full object-cover transition-transform duration-700 group-hover:scale-105"
                                />
                            </figure>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default GallerySection;
